import ChatroomList from '../components/ChatroomList'
import {connect} from 'react-redux'
import {actions} from '../../../modules/chat'

const mapStateToProps = state => {
  return {
    chatrooms: state.chat.chatrooms,
    showingChatroomId: state.chat.showingChatroomId
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchChatrooms: () => dispatch(actions.fetchChatrooms()),
    setShowingChatroomId: chatroomId => dispatch(actions.setShowingChatroomId(chatroomId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatroomList)



// WEBPACK FOOTER //
// ./src/routes/support/containers/SupportContainer.js